define(function (require) {
    'use strict';

    var _ = require('underscore');


    var _asBytesToSizeResult = function (value, symbol) {
        return {
            value: value,
            symbol: symbol
        };
    };

    return {

        /**
         * Standards for digital storage units of measure.
         * METRIC sets 1000 as the unit, following the SI (International System Of Units) standard (10 ^ 3), and BINARY sets
         * 1024 as the unit, following the IEC (International Electrotechnical Commission) standard (2 ^ 10).
         * For measuring file sizes, the metric system is mostly common.
         *
         * @type {{METRIC: {UNIT: number, SYMBOLS: string[]}, BINARY: {UNIT: number, SYMBOLS: string[]}}}
         */
        MEASUREMENT_SYSTEM: {
            METRIC: {
                UNIT: 1000,
                SYMBOLS: ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            },
            BINARY: {
                UNIT: 1024,
                SYMBOLS: ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
            }
        },

        /**
         * File size units enumeration for converting bytes to another format.
         * @see NumberFormats.bytesToSize()
         */
        FILE_SIZE_UNIT: {
            BYTES: 0,
            KILOBYTES: 1,
            MEGABYTES: 2,
            GIGABYTES: 3,
            TERABYTES: 4,
            PETABYTES: 5,
            EXABYTES: 6,
            ZETTABYTES: 7,
            YOTTABYTES: 8
        },

        /**
         * Converts file size in bytes to a formatted size.
         *
         * @param bytes The size to be formatted, in bytes.
         * @param measurementSystem (Optional) The standard for the measurement multiplier.
         * Pass <code>NumberFormats.MEASUREMENT_SYSTEM.METRIC</code> to use 1000 as the multiplier (1 KB = 1000 Bytes),
         * or <code>NumberFormats.MEASUREMENT_SYSTEM.BINARY</code> to use 1024 as the multiplier (1 KiB = 1024 Bytes).
         * Default is <code>NumberFormats.MEASUREMENT_SYSTEM.METRIC</code>.
         * @param unit (Optional) Force a specific file size unit in the result, e.g. KB, MB.
         * Use the <code>NumberFormats.FILE_SIZE_UNIT</code> enum as parameter. By default, the function will figure
         * out the unit on its own by determining the order of magnitude from the passed <code>bytes</code> value.
         * @param precision (Optional) The desired decimal precision for the formatting, default is 2 (e.g. 1.00).
         * @returns {*|boolean} An object in the format <code>{value: number, symbol: string}</code> if formatting
         * succeed, <code>false</code> otherwise.
         */
        bytesToSize: function (bytes, measurementSystem, unit, precision) {
            if (_.isNaN(bytes) || bytes < 0) {
                return false;
            }
            if (_.isUndefined(measurementSystem) || !_.contains(this.MEASUREMENT_SYSTEM, measurementSystem)) {
                measurementSystem = this.MEASUREMENT_SYSTEM.METRIC;
            }
            if (bytes === 0) {
                return _asBytesToSizeResult(0, measurementSystem.SYMBOLS[0]);
            }
            var exponent;
            if (!_.isNaN(unit) && _.contains(this.FILE_SIZE_UNIT, unit)) {
                exponent = unit;
            } else {
                exponent = parseInt(Math.floor(Math.log(bytes) / Math.log(measurementSystem.UNIT)), 10);
            }
            if (exponent === 0) {
                return _asBytesToSizeResult(bytes, measurementSystem.SYMBOLS[exponent]);
            }
            if (_.isNaN(precision) || precision < 0) {
                precision = 2;
            }
            return _asBytesToSizeResult(
                (bytes / Math.pow(measurementSystem.UNIT, exponent)).toFixed(precision),
                measurementSystem.SYMBOLS[exponent]);
        },

        isPlural: function (num) {
            if (_.isNaN(num)) {
                throw new Error('num is not a number or undefined');
            }
            return num > 1 || num === 0;
        }

    };
});
